import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Permission from "./Permission";
import Tutorial from "./Tutorial";
import Model from "./Model";
import JsonPermission from "./permission/JsonPermission";
export class Role extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'role_id',
      content: null
    });
    _defineProperty(this, "RoleId", {
      fieldName: 'role_id',
      content: null
    });
    _defineProperty(this, "RoleName", {
      fieldName: 'role_name',
      content: null
    });
    _defineProperty(this, "RolePermissions", {
      fieldName: 'role_permissions',
      model: Permission,
      content: []
    });
    _defineProperty(this, "RoleTutorials", {
      fieldName: 'role_tutorials',
      model: Tutorial,
      content: null
    });
    _defineProperty(this, "defaultPermissions", {
      fieldName: 'default_permissions',
      model: JsonPermission,
      content: []
    });
  }
  getRoleName() {
    var _this$RoleName;
    return (_this$RoleName = this.RoleName) === null || _this$RoleName === void 0 ? void 0 : _this$RoleName.content;
  }
  getName() {
    return this.RoleName.content;
  }
  getTutorials() {
    return this.RoleTutorials.content;
  }
  isAffiliate() {
    return this.getName() === Role.SELLER_ROLE;
  }
  static getManagerRoles() {
    return [Role.ADMIN_ROLE, Role.MANAGER_ROLE];
  }
  static getSellerRoles() {
    return [Role.SELLER_ROLE, Role.INFLUENCER_ROLE];
  }
  static getWarehouseRoles() {
    return [Role.WAREHOUSE_ROLE, Role.CALL_AGENT_ROLE, Role.ADVERTISER_ROLE];
  }
  static getManagerAndSellerRoles() {
    return [...Role.getManagerRoles(), ...Role.getSellerRoles()];
  }
  static getManagerAndWarehouseRoles() {
    return [...Role.getManagerRoles(), ...Role.getWarehouseRoles()];
  }
  static getAllRoles() {
    return [Role.WAREHOUSE_ROLE, Role.CALL_AGENT_ROLE, Role.ADVERTISER_ROLE, Role.SELLER_ROLE, Role.INFLUENCER_ROLE, Role.ADMIN_ROLE, Role.MANAGER_ROLE];
  }
  getDefaultPermissions() {
    return this.defaultPermissions.content;
  }
}
_defineProperty(Role, "ADMIN_ROLE", 'admin');
_defineProperty(Role, "MANAGER_ROLE", 'manager');
_defineProperty(Role, "ADVERTISER_ROLE", 'advertiser');
_defineProperty(Role, "SELLER_ROLE", 'seller');
_defineProperty(Role, "AFFILIATE_ROLE", 'affiliate');
_defineProperty(Role, "INFLUENCER_ROLE", 'influencer');
_defineProperty(Role, "CALL_AGENT_ROLE", 'call-agent');
_defineProperty(Role, "WAREHOUSE_ROLE", 'warehouse');
export default Role;